import React from 'react';
import Link from 'next/link';
import { ShoppingBag, ArrowRight } from 'lucide-react';

/* Landing "Cam etiketi koleksiyonu" bölümü (PRD-53). Fiyat YAZILMAZ: Apple 3.1.1 görünmezlik
 * modeli gereği (doküman 43 §13, görünmezlik notu) — fiyat yalnız /magaza sayfasında. */
export default function StoreTeaser({ L }: any) {
  const S = L.store;
  return (
    <section id="magaza" className="py-14 md:py-20 relative">
      <div className="divider-glow mb-16 mx-12" />
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
        <div className="reveal rounded-2xl overflow-hidden border border-white/10 bg-[#141517]">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/magaza/koleksiyon.png" alt={S.title} loading="lazy" className="w-full h-auto block" />
        </div>
        <div>
          <div className="reveal inline-block glass-panel px-4 py-2 rounded-full text-xs text-[#F59300] uppercase tracking-widest font-semibold mb-6">
            {S.badge}
          </div>
          <h2 className="reveal reveal-delay-1 text-3xl md:text-4xl font-black text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            {S.title}
          </h2>
          <p className="reveal reveal-delay-2 text-gray-400 leading-relaxed mb-6">{S.subtitle}</p>
          <ul className="reveal reveal-delay-2 space-y-2 mb-8">
            {S.bullets.map((b: string) => (
              <li key={b} className="flex items-start gap-2 text-sm text-gray-300">
                <ShoppingBag size={16} className="text-[#F59300] mt-0.5 shrink-0" /> {b}
              </li>
            ))}
          </ul>
          <Link href="/magaza" className="reveal reveal-delay-3 btn-shimmer inline-flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-white text-sm">
            {S.cta} <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
